export enum UserSegmentType {
  SimpleUser = 'SimpleUser',
  BusinessUser = 'BusinessUser',
  MarketUser = 'MarketUser',
}
